<template>
  <div>
    <RedteaReadyWeb v-if="!isMobile"></RedteaReadyWeb>
    <RedteaReadyMobile v-if="isMobile"></RedteaReadyMobile>
  </div>
</template>
<script>
import RedteaReadyWeb from './RedteaReady-web.vue'
import RedteaReadyMobile from './RedteaReady-mobile.vue'
export default {
  name: 'RedteaReady',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    RedteaReadyWeb,
    RedteaReadyMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
